export const INTERNAL_IDENTIFIER_VALIDATION_REGEX = /^[a-zA-Z0-9_-]+$/i;

export const EMAIL_VALIDATION_REGEX =
  /^[A-Z0-9.'_%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;

export const URL_VALIDATION_REGEX =
  // oxlint-disable-next-line eslint(no-useless-escape) -- FIXME: pre-existing error: Unnecessary escape character '+'
  // oxlint-disable-next-line eslint(no-useless-escape) -- FIXME: pre-existing error: Unnecessary escape character '+'
  /^(https?:\/\/)(www\.)?[a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)$/i;
